import NotificationFilter from 'interfaces/NotificationFilter';
import { getAuthHeaders, getSearchParamsString } from './api';
import { handleResponseConversionToJSON } from './utility';

const getNotifications = async (
    authToken: string,
    take: number,
    filters: NotificationFilter = {}
) => {
    const headers = getAuthHeaders(authToken);
    return fetch(
        `api/Notifications/GetNotifications?${getSearchParamsString({
            ...filters,
            take,
        })}`,
        {
            method: 'GET',
            headers,
        }
    );
};

const getUnreadNotificationsCount = async (
    authToken: string,
    filters: NotificationFilter = {}
) => {
    const headers = getAuthHeaders(authToken);
    return fetch(
        `api/Notifications/GetUnreadNotificationsCount?${getSearchParamsString(
            filters
        )}`,
        {
            method: 'GET',
            headers,
        }
    );
};

const getNotificationTypeOptions = async (authToken: string) => {
    const headers = getAuthHeaders(authToken);
    return fetch('api/Notifications/GetNotificationTypeOptions', {
        method: 'GET',
        headers,
    }).then(handleResponseConversionToJSON);
};

export {
    getNotifications,
    getUnreadNotificationsCount,
    getNotificationTypeOptions,
};
